/* eslint-disable jsx-a11y/alt-text */
import React, {Component} from "react";
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
// const IpfsHttpClient = require('ipfs-http-client')
// const { globSource } = IpfsHttpClient
// const ipfs = IpfsHttpClient()

// const ipfs = ipfsClient({
//   host: "ipfs.infura.io",
//   port: 5001,
//   protocol: "https",
// }); // leaving out the arguments will default to these values

const IpfsHttpClient = require("ipfs-http-client");

const ipfs = IpfsHttpClient({
  host: "ipfs.infura.io",
  port: 5001,
  protocol: "https",
});

class TodoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdd: false,
      fullname: "",
      natureCol: "",
      authors: [],
      precNature: false,
      buffer: null,
      uploading: false,
      artist: localStorage.getItem("artist", ""),
    };
  }
  async componentDidMount() {
    // let res = ipfs.add(this.state.buffer, (error, result) => {
    //   console.log("Ipfs result", result);
    //   if (error) {
    //     console.error(error);
    //     return;
    //   }
    //   console.log("dddddd");
    // });
  }

  captureFile = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const reader = new window.FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      this.setState({buffer: Buffer(reader.result)});
      console.log("buffer", this.state.buffer);
    };
  };

  onSubmit = async (event) => {
    event.preventDefault();
    console.log("Submitting file to ipfs...");
    this.setState({uploading: true});
    for await (const file of ipfs.add(this.state.buffer)) {
      if (file && file.path) {
        this.setState({uploading: false});
        this.props.createTask(
          this.title.value,
          this.category.value,
          file.path,
          JSON.stringify(this.state.authors)
        );
      } else {
        this.setState({uploading: false});
      }
    }
    // ipfs.add(this.state.buffer, (error, result) => {
    //   console.log("Ipfs result", result);
    //   if (error) {
    //     console.error(error);
    //     return;
    //   }

    //   this.props.createTask(
    //     this.title.value,
    //     this.category.value,
    //     result[0].hash,
    //     JSON.stringify(this.state.authors)
    //   );

    //   // this.state.contract.methods
    //   //   .set(result[0].hash)
    //   //   .send({from: this.state.account})
    //   //   .then((r) => {
    //   //     return this.setState({memeHash: result[0].hash});
    //   //   });
    // });
  };
  render() {
    return (
      <div id="content">
        <div className="rn-contact-area rn-section-gap bg_color--1">
          <div className="contact-form--1" style={{width: 1000}}>
            <div className="container">
              <div className="row align-items-start">
                <div
                  className="modal bd-example-modal-lg"
                  id="exampleModal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  data-backdrop="static">
                  <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Nouveau
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="col-lg-12">
                          <div className="form-wrapper">
                            <form
                              // onSubmit={(event) => {
                              //   event.preventDefault();

                              //   this.props.createTask(
                              //     this.title.value,
                              //     this.category.value,
                              //     this.content.value,
                              //     JSON.stringify(this.state.authors)
                              //   );
                              // }}

                              onSubmit={this.onSubmit}>
                              <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                  <label>
                                    <input
                                      id="titre"
                                      ref={(input) => {
                                        this.title = input;
                                      }}
                                      type="text"
                                      className="form-control"
                                      placeholder="Title"
                                      required
                                    />
                                  </label>
                                  <label>
                                    <div className="form-group">
                                      <select
                                        className="form-control"
                                        id="exampleFormControlSelect1"
                                        ref={(input) => {
                                          this.category = input;
                                        }}>
                                        <option>Musique</option>
                                        <option>Art</option>
                                        <option>Mode</option>
                                      </select>
                                    </div>
                                  </label>
                                  <label>
                                    <input
                                      type="file"
                                      onChange={this.captureFile}
                                      id="file"
                                      className="form-control"
                                      placeholder="File"
                                    />
                                  </label>
                                  {this.state.uploading === false ? (
                                    <button
                                      // hidden={true}
                                      className="rn-button-style--2 btn_solid"
                                      type="submit"
                                      value="submit"
                                      name="submit"
                                      id="mc-embedded-subscribe">
                                      Envoyer pour validation
                                    </button>
                                  ) : (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a className="rn-button-style--2 btn_solid">
                                      Entrain de chargé...
                                    </a>
                                  )}
                                </div>
                                <div className="col-lg-4 offset-lg-1 col-sm-12">
                                  <label>
                                    <input
                                      id="fullname"
                                      onChange={(input) =>
                                        this.setState({
                                          fullname: input.target.value,
                                        })
                                      }
                                      value={this.state.fullname}
                                      type="text"
                                      className="form-control"
                                      placeholder="Nom complet"
                                    />
                                  </label>

                                  {this.state.natureCol !== "Autre" &&
                                  this.state.precNature === false ? (
                                    <label>
                                      <div className="form-group">
                                        <select
                                          className="form-control"
                                          id="exampleFormControlSelect1"
                                          value={this.state.natureCol}
                                          onChange={(input) =>
                                            this.setState(
                                              {
                                                natureCol: input.target.value,
                                                precNature:
                                                  input.target.value ===
                                                  "Autre",
                                              },
                                              () => {
                                                if (
                                                  this.state.precNature === true
                                                ) {
                                                  this.setState({
                                                    natureCol: "",
                                                  });
                                                }
                                              }
                                            )
                                          }>
                                          <option>Nature collaboration</option>
                                          <option>Auteur</option>
                                          <option>Compositeur</option>
                                          <option>Auteur/Compositeur</option>
                                          <option>Chanteur</option>
                                          <option>Financière</option>
                                          <option>Autre</option>
                                        </select>
                                      </div>
                                    </label>
                                  ) : (
                                    <label>
                                      <input
                                        id="nature"
                                        onChange={(input) =>
                                          this.setState({
                                            natureCol: input.target.value,
                                          })
                                        }
                                        value={this.state.natureCol}
                                        type="text"
                                        className="form-control"
                                        placeholder="Preciser la Nature"
                                      />
                                    </label>
                                  )}
                                  <center>
                                    <span
                                      style={{}}
                                      className="btn btn-primary bnt-sm"
                                      onClick={() => {
                                        if (
                                          this.state.natureCol !== "Autre" &&
                                          this.state.natureCol !==
                                            "Nature collaboration"
                                        ) {
                                          this.setState(
                                            {
                                              authors: [
                                                ...this.state.authors,
                                                {
                                                  fullname: this.state.fullname,
                                                  nature: this.state.natureCol,
                                                },
                                              ],
                                            },
                                            () => {
                                              this.setState({
                                                natureCol: "",
                                                fullname: "",
                                                precNature: false,
                                              });
                                            }
                                          );
                                        }
                                      }}>
                                      Ajouter à la liste
                                    </span>
                                  </center>

                                  <br />

                                  <label>
                                    <ul>
                                      {this.state.authors.map((aut, key) => (
                                        <li style={{fontSize: 12}} key={key}>
                                          {aut.fullname} - {aut.nature}
                                        </li>
                                      ))}
                                    </ul>
                                  </label>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12" style={{marginTop: -50}}>
                  <button
                    style={{float: "right", marginRight: 20}}
                    data-toggle="modal"
                    data-target="#exampleModal"
                    data-whatever="@getbootstrap"
                    className="rn-button-style--2 btn_solid">
                    Ajouter
                  </button>
                  <div className="rn-column-area rn-section-gap bg_color--1">
                    <div className="container">
                      <div className="row">
                        {this.props.tasks
                          .filter((a) =>
                            JSON.stringify(a.mainAuthor)
                              .toLowerCase()
                              .includes(this.state.artist.toLowerCase())
                          )
                          .map((task, key) => (
                            <div
                              className="col-lg-4 col-md-6 col-12 mt_sm--30 mb-5"
                              key={key}>
                              <img
                                src={`https://cdn.iconscout.com/icon/free/png-256/checked-1504964-1274039.png`}
                                style={{
                                  height: 20,
                                  width: 20,
                                  objectFit: "cover",
                                  position: "absolute",
                                  top: 5,
                                  right: 20,
                                }}
                              />
                              <div
                                className="single-column custom-color custom-color--1"
                                style={{minHeight: 300}}>
                                <div className="list-style-inner">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      {!task.contents.includes("http") ? (
                                        <img
                                          src={`https://ipfs.infura.io/ipfs/${task.contents}`}
                                          style={{
                                            height: 100,
                                            width: 100,
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={`https://static-s.aa-cdn.net/img/ios/1139650210/7aa30ff242d0065a90970f5d6714f445?v=1`}
                                          style={{
                                            height: 100,
                                            width: 100,
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                    </div>

                                    <div className="col-lg-7">
                                      <p style={{color: "#fff", height: 10}}>
                                        -{" "}
                                        {JSON.parse(task.authors)[0].fullname
                                          .length < 10
                                          ? JSON.parse(task.authors)[0].fullname
                                          : JSON.parse(
                                              task.authors
                                            )[0].fullname.substring(0, 10) +
                                            "..."}
                                      </p>

                                      <p style={{color: "#fff"}}>
                                        - {task.category}
                                      </p>
                                    </div>
                                  </div>
                                  {/* <h5 style={{color: "#fff", fontWeight: "300"}}>
                                  {task.title}
                                </h5> */}

                                  <h6
                                    style={{
                                      color: "#fff",
                                      marginTop: 10,
                                    }}>
                                    {task.title}
                                  </h6>
                                  <p style={{color: "#fff", height: 10}}>
                                    {"Collaborateur"}
                                  </p>
                                  <ul className="list-style--1">
                                    {JSON.parse(task.authors).map(
                                      (aut, key) => {
                                        if (key > 0) {
                                          return (
                                            <li
                                              key={key}
                                              style={{fontSize: 12}}>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="feather feather-check">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                              </svg>
                                              {aut.fullname} - {aut.nature}
                                            </li>
                                          );
                                        }
                                      }
                                    )}
                                  </ul>
                                </div>

                                <Link
                                  to="listen"
                                  style={{
                                    position: "absolute",
                                    right: 30,
                                    bottom: 10,
                                  }}>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      localStorage.setItem("title", task.title)
                                    }>
                                    Ecoutes
                                  </button>
                                </Link>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ul id="completedTaskList" className="list-unstyled"></ul>
      </div>
    );
  }
}

export default TodoList;
